import React from 'react';
import PropTypes from 'prop-types';
//import { getUrl, getDescText, getPublishDate, getEventDate, cacheFunc } from '../../common/services/builders';
import { getUrl, getDescText } from '../../common/services/builders';

function ListingCard({ entry }) {

    //var url = "/innovation-network-2/media-and-events/case-studies.aspx";
    //var url = "/microsites/non-metallic/insights.aspx";
    //var url = "/insights";

    var url = window.location.pathname;

    url = url.replace(".aspx", "");
    
    url = url + '/' + entry.sys.slug;
	

    return (
        <div className="column large-4">
            <article className="ui-card" style={{minHeight: 460 + 'px'}}>
                <div className="ui-card__image">
                    <div className="ui-card__image-container" style={renderImage(entry)}></div>
                </div>
                <div className="ui-card__content  text-center">
                    <h3 className="ui-card__heading"><a href={url}>{entry.title}</a></h3>
                    <p className="ui-card__text">{getDescText(entry)}</p>
                    <div className="ui-card__tags">
                        {renderTags(entry)}
                    </div>
                </div>
            </article>
        </div>
    );

}
function renderImage(entry){
    let styles = {};

    var heroImage = entry !=null && entry.heroImage !=null ? entry.heroImage.asset.sys.uri : null;
    var thumbnailImage = entry !=null && entry.thumbnailImage !=null ? entry.thumbnailImage.asset.sys.uri : null;









    if(thumbnailImage != null){

        if (thumbnailImage.includes("microsite"))
        {
            thumbnailImage = thumbnailImage.replace(/^\/[^/]+\/[^/]+/, "");
        }
        else
        {
            thumbnailImage = "https://twi-global.com" + thumbnailImage
        }

        
        thumbnailImage = thumbnailImage.replace(/\?.*$/, "");
        styles = {backgroundImage: `url(${thumbnailImage}?h=300&w=500)`};
    }
    else if(heroImage != null){    
        if (heroImage.includes("microsite"))
        {
            heroImage = heroImage.replace(/^\/[^/]+\/[^/]+/, "");
        }
        else
        {
            heroImage = "https://twi-global.com" + heroImage
        }
        heroImage = heroImage.replace(/\?.*$/, "");
        styles = {backgroundImage: `url(${heroImage}?h=300&w=500)`};
    }
    else{
        styles = {backgroundImage: `url(/site-elements/images/hero/hero-slider-1.jpg?h=300&w=500)`};
    }
    return styles;
}
function renderTags(entry) {
    if(entry && entry.industry){
        if(!Array.isArray(entry.industry)){
            return <span className="tag">{entry.industry.name}</span>;
        }
        else{
            return entry.industry.map((e, index) => <span key={index} className="tag">{e.name}</span>);
        }
    }
    else{
        return <span className="tag">All</span>;
    }
}

ListingCard.propTypes = {
    entry: PropTypes.object,
};

export default ListingCard;